import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'

// Detection de l'environnement et du contexte d'exécution
const isProduction = import.meta.env.PROD;
const baseUrl = './'; // Toujours utiliser un chemin relatif pour la cohérence

// Version fixe pour éviter des rechargements en boucle en développement
const buildTime = import.meta.env.VITE_BUILD_TIME || '2025-03-27T12:00:00.000Z';
// Générer un identifiant unique pour cette session
const sessionId = Date.now().toString(36) + Math.random().toString(36).substring(2);

console.log('🚀 Application démarrage avec informations détaillées:', {
  mode: import.meta.env.MODE,
  base: import.meta.env.BASE_URL,
  prod: isProduction,
  baseUrl: baseUrl,
  url: window.location.href,
  path: window.location.pathname,
  hash: window.location.hash,
  origin: window.location.origin,
  host: window.location.host,
  hostname: window.location.hostname,
  href: window.location.href,
  protocol: window.location.protocol,
  documentURI: document.documentURI,
  documentURL: document.URL,
  referrer: document.referrer || 'none',
  timestamp: new Date().toISOString(),
  buildTime: buildTime,
  sessionId: sessionId
});

// Logique améliorée pour éviter des rechargements en boucle tout en assurant
// que les changements de l'éditeur sont toujours reflétés
const isPreviewEnvironment = window.location.hostname.includes("lovable") || 
                            window.location.hostname.includes("preview");

// En mode prévisualisation, on s'assure que le cache est contourné
if (isPreviewEnvironment) {
  console.log('📋 Mode prévisualisation détecté, optimisation du chargement');
  // On ajoute un listener pour s'assurer que le DOM est complètement chargé
  window.addEventListener('DOMContentLoaded', () => {
    console.log('🔄 DOM chargé complètement, application prête');
  });
}

// Enhanced error handling
window.addEventListener('error', function(event) {
  console.error('Erreur globale capturée:', event.error, {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    stack: event.error?.stack,
    url: window.location.href,
    sessionId: sessionId
  });
});

// Capture des erreurs de ressources
window.addEventListener('unhandledrejection', function(event) {
  console.error('Promesse rejetée non gérée:', event.reason);
});

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Élément racine non trouvé");

const root = createRoot(rootElement);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
